angular.module('controllers').controller('userController', ['$scope', '$rootScope', '$controller', '$http', 'Crud', '$mdDialog', '$route', '$routeParams', '$location',
	function ($scope, $rootScope, $controller, $http, Crud, $mdDialog, $route, $routeParams, $location) {
		$rootScope.path = '/user';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'user';
		$scope.pathTemplate = 'users/users';
		$scope.title = 'Utilizatori';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'username';
		$scope.defaultItem = 10;
    $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Detalii', 'filter':0, 'filterType':'input'},
			'user_image':{'label':'Imagine', 'filter':0},
			'username':{'label':'Username', 'filter':1, 'filterType':'input'},
			'user_last_name':{'label':'Nume', 'filter':1, 'filterType':'input'},
			'user_first_name':{'label':'Prenume', 'filter':1, 'filterType':'input'},
			'user_email':{'label':'Email', 'filter':1, 'filterType':'input'},
      'role':{'label':'Roluri', 'filter':0},
      'interior_no':{'label':'Int. tel.', 'filter':0},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);

		$scope.additionals['content_type'] = 'form-urlencoded';
                $scope.additionals['columnDisplay'] = 'username';
		$scope.additionals['publicPath'] = '/images/users';

                $scope.additionals['togglePassword'] = function(inputId) {
                          var x = document.getElementById(inputId);
                          if (x.type === 'password') {
                            x.type = 'text';
                          } else {
                            x.type = 'password';
                          }
                }

		/* get dependent fields */
		$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {
					$scope.additionals['roles'] = data.roles;
              $scope.additionals['interiors'] = data.interiors;
				});
		}

        $scope.additionals['searchTermRole'];
        $scope.additionals['clearSearchTermRole'] = function() {
            $scope.additionals['searchTermRole'] = '';
        };
        $scope.additionals['onSearchChangeRole'] = function(ev) {
            ev.stopPropagation();
        };

        $scope.additionals['searchTermInterior'];
        $scope.additionals['clearSearchTermInterior'] = function() {
            $scope.additionals['searchTermInterior'] = '';
        };
        $scope.additionals['onSearchChangeInterior'] = function(ev) {
            ev.stopPropagation();
        };

        $scope.additionals['function']= function(ev, data) {
			angular.element(document.querySelector('#fileImage')).val('');
		}

		$scope.additionals['functionResult']= function(ev, data) {

		}

		/* delete existing image */
		$scope.additionals['deleteImage'] = function (ev, model) {
			model['route'] = 'deleteImage';
			Crud.post('form-urlencoded', model, $scope.path + '/deleteImage')
				.success(function () {
					$scope.modelData['user_image'] = '';
					$scope.modelData['image'] = '';
					angular.element(document.querySelector('#image')).attr("src", '');
					$scope.image = '';

					model['multipleImages'] = '';
					model['user_image'] = '';
					model['image'] = '';
					var currentElement = angular.element(ev.currentTarget);
					angular.element(document.querySelector('#crop' + currentElement[0]['id'] + ' #img')).css('display', 'none');
				}).error(function (data) {
				$scope.errors = data.errors;

			});
		}

		$scope.createModelUser = function (ev, path, section) {
			$scope.additionals['function']= function(ev, data) {
				angular.element(document.querySelector('#fileImage')).val('');
				if($scope.action != 'show') {
					$scope.action = 'store';
				}
			}
			$scope.createModel(ev, path, section);
		}

		$scope.editModelUser = function (ev, path, model, section) {
			$scope.additionals['function']= function(ev, model) {
				angular.element(document.querySelector('#fileImage')).val('');
						if($scope.action != 'show') {
							$scope.action = 'updateUser';
						}
            model.role_id = [];
            angular.forEach(model.role, function (item, key) {
                model.role_id[key] = item.id;
            });
        }
			$scope.editModel(ev, path, model, section);
		}

		$scope.editMultipleModelUser = function (ev, path) {
			$scope.additionals['function']= function(ev, model) {
				angular.element(document.querySelector('#fileImage')).val('');
				$scope.action = 'updatemultiple';

		        angular.forEach(model, function (item, key) {
							item.role_id = [];
							angular.forEach(item.role, function (itemRole, keyRole) {
								item.role_id[keyRole] = itemRole.id;
							});
            });

			}
			$scope.editMultipleModel(ev, path);
		}

		/* change password */
		$scope.changePasswordModel = function (ev, path, model) {
			if($scope.mode_action == 'page') {
				$scope.controlSH = true;
				$scope.action = 'changepassword';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
				$scope.additionals['invalid'] = '';
				var currentModel = {};
				angular.forEach(model, function (item, key) {
					currentModel[key] = item;
				});
				$scope.modelData = currentModel;
				$scope.cancel = function () {
					$scope.modelData = {};
					$scope.errors = {};
					$scope.controlSH = false;
				};

				$scope.updateModel = function () {
                    $scope.additionals['buttonDisabled'] = true;
					$scope.isLoading = true;
					$scope.modelData['route'] = 'changePassword';
					Crud.post('form-urlencoded', $scope.modelData, path +'/changePassword')
						.success(function (data) {
							if (!angular.isUndefined(data.invalid)) {
								$scope.additionals['invalid'] = data.invalid;
							}
							currentModel = {};
							$scope.modelData = {};
							$scope.errors = {};
							$scope.isLoading = false;
                            $scope.controlSH = false;
                            $scope.additionals['buttonDisabled'] = false;
						})
						.error(function (data) {
							$scope.errors = data.errors;
							$scope.isLoading = false;
                            $scope.additionals['buttonDisabled'] = false;
						});

				};


			}
			if($scope.mode_action == 'dialog') {
				$scope.additionals['invalid'] = '';
				var currentModel = {};
				angular.forEach(model, function (item, key) {
					currentModel[key] = item;
				});

				$mdDialog.show({
					controller: DialogController,
					templateUrl: 'changePasswordDialog.tmpl.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					locals: {pathTemplate: $scope.pathTemplate, model: currentModel, additionals: $scope.additionals}
				}).then(function () {
					if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models.data)) {
						$scope.getElement($scope.models.data, currentModel, $rootScope.typeId);
					}
					if (!angular.isUndefined($scope.modelData)) {
						$scope.modelData = currentModel;
					}
				});
				DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'additionals'];
				function DialogController($scope, $mdDialog, pathTemplate, model, additionals) {
					$scope.pathTemplate = pathTemplate;
					$scope.modelData = model;
                    $scope.additionals = additionals;

                    $scope.cancel = function () {
						$mdDialog.cancel();
					};
					$scope.updateModel = function () {
                        $scope.additionals['buttonDisabled'] = true;
						$scope.isLoading = true;
						$scope.modelData['route'] = 'changePassword';
						Crud.post('form-urlencoded', $scope.modelData, path +'/changePassword')
							.success(function (data) {
								if (!angular.isUndefined(data.invalid)) {
									$scope.additionals['invalid'] = data.invalid;
								}
								$mdDialog.hide();
								currentModel = {};
								$scope.isLoading = false;
                                $scope.additionals['buttonDisabled'] = false;
							})
							.error(function (data) {
								$scope.errors = data.errors;
								$scope.isLoading = false;
                                $scope.additionals['buttonDisabled'] = false;
							});

					};
				}
			}
		};

                /* add pin */
                $scope.addPinModel = function (ev, path, model) {
                        if($scope.mode_action == 'page') {
                                $scope.controlSH = true;
                                $scope.action = 'addpin';
                                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
                                $scope.additionals['invalid'] = '';
                                var currentModel = {};
                                angular.forEach(model, function (item, key) {
                                        currentModel[key] = item;
                                });
                                $scope.modelData = currentModel;
                                $scope.cancel = function () {
                                        $scope.modelData = {};
                                        $scope.errors = {};
                                        $scope.controlSH = false;
                                };

                                $scope.updateModel = function () {
                                $scope.additionals['buttonDisabled'] = true;
                                        $scope.isLoading = true;
                                        $scope.modelData['route'] = 'addPin';
                                        Crud.post('form-urlencoded', $scope.modelData, path +'/addPin')
                                                .success(function (data) {
                                                        if (!angular.isUndefined(data.invalid)) {
                                                                $scope.additionals['invalid'] = data.invalid;
                                                        }
                                                        currentModel = {};
                                                        $scope.modelData = {};
                                                        $scope.errors = {};
                                                        $scope.isLoading = false;
                                                        $scope.controlSH = false;
                                                        $scope.additionals['buttonDisabled'] = false;
                                                })
                                                .error(function (data) {
                                                        $scope.errors = data.errors;
                                                        $scope.isLoading = false;
                                                        $scope.additionals['buttonDisabled'] = false;
                                                });

                                };


                        }
                        if($scope.mode_action == 'dialog') {
                                $scope.additionals['invalid'] = '';
                                var currentModel = {};
                                angular.forEach(model, function (item, key) {
                                        currentModel[key] = item;
                                });

                                $mdDialog.show({
                                        controller: DialogController,
                                        templateUrl: 'addPinDialog.tmpl.html',
                                        parent: angular.element(document.body),
                                        targetEvent: ev,
                                        clickOutsideToClose: true,
                                        locals: {pathTemplate: $scope.pathTemplate, model: currentModel, additionals: $scope.additionals}
                                }).then(function () {
                                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models.data)) {
                                                $scope.getElement($scope.models.data, currentModel, $rootScope.typeId);
                                        }
                                        if (!angular.isUndefined($scope.modelData)) {
                                                $scope.modelData = currentModel;
                                        }
                                });
                                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'additionals'];
                                function DialogController($scope, $mdDialog, pathTemplate, model, additionals) {
                                        $scope.pathTemplate = pathTemplate;
                                        $scope.modelData = model;
                                        $scope.additionals = additionals;

                                        $scope.cancel = function () {
                                                $mdDialog.cancel();
                                        };
                                        $scope.updateModel = function () {
                                        $scope.additionals['buttonDisabled'] = true;
                                                $scope.isLoading = true;
                                                $scope.modelData['route'] = 'addPin';
                                                Crud.post('form-urlencoded', $scope.modelData, path +'/addPin')
                                                        .success(function (data) {
                                                                if (!angular.isUndefined(data.invalid)) {
                                                                        $scope.additionals['invalid'] = data.invalid;
                                                                }
                                                                $mdDialog.hide();
                                                                currentModel = {};
                                                                $scope.isLoading = false;
                                                                $scope.additionals['buttonDisabled'] = false;
                                                        })
                                                        .error(function (data) {
                                                                $scope.errors = data.errors;
                                                                $scope.isLoading = false;
                                                                $scope.additionals['buttonDisabled'] = false;
                                                        });

                                        };
                                }
                        }
                };

                /* change pin */
                $scope.changePinModel = function (ev, path, model) {
                        if($scope.mode_action == 'page') {
                                $scope.controlSH = true;
                                $scope.action = 'changepin';
                                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
                                $scope.additionals['invalid'] = '';
                                var currentModel = {};
                                angular.forEach(model, function (item, key) {
                                        currentModel[key] = item;
                                });
                                $scope.modelData = currentModel;
                                $scope.cancel = function () {
                                        $scope.modelData = {};
                                        $scope.errors = {};
                                        $scope.controlSH = false;
                                };

                                $scope.updateModel = function () {
                                $scope.additionals['buttonDisabled'] = true;
                                        $scope.isLoading = true;
                                        $scope.modelData['route'] = 'changePin';
                                        Crud.post('form-urlencoded', $scope.modelData, path +'/changePin')
                                                .success(function (data) {
                                                        if (!angular.isUndefined(data.invalid)) {
                                                                $scope.additionals['invalid'] = data.invalid;
                                                        }
                                                        currentModel = {};
                                                        $scope.modelData = {};
                                                        $scope.errors = {};
                                                        $scope.isLoading = false;
                                                        $scope.controlSH = false;
                                                        $scope.additionals['buttonDisabled'] = false;
                                                })
                                                .error(function (data) {
                                                        $scope.errors = data.errors;
                                                        $scope.isLoading = false;
                                                        $scope.additionals['buttonDisabled'] = false;
                                                });

                                };


                        }
                        if($scope.mode_action == 'dialog') {
                                $scope.additionals['invalid'] = '';
                                var currentModel = {};
                                angular.forEach(model, function (item, key) {
                                        currentModel[key] = item;
                                });

                                $mdDialog.show({
                                        controller: DialogController,
                                        templateUrl: 'changePinDialog.tmpl.html',
                                        parent: angular.element(document.body),
                                        targetEvent: ev,
                                        clickOutsideToClose: true,
                                        locals: {pathTemplate: $scope.pathTemplate, model: currentModel, additionals: $scope.additionals}
                                }).then(function () {
                                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models.data)) {
                                                $scope.getElement($scope.models.data, currentModel, $rootScope.typeId);
                                        }
                                        if (!angular.isUndefined($scope.modelData)) {
                                                $scope.modelData = currentModel;
                                        }
                                });
                                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'additionals'];
                                function DialogController($scope, $mdDialog, pathTemplate, model, additionals) {
                                        $scope.pathTemplate = pathTemplate;
                                        $scope.modelData = model;
                                        $scope.additionals = additionals;

                                        $scope.cancel = function () {
                                                $mdDialog.cancel();
                                        };
                                        $scope.updateModel = function () {
                                        $scope.additionals['buttonDisabled'] = true;
                                                $scope.isLoading = true;
                                                $scope.modelData['route'] = 'changePin';
                                                Crud.post('form-urlencoded', $scope.modelData, path +'/changePin')
                                                        .success(function (data) {
                                                                if (!angular.isUndefined(data.invalid)) {
                                                                        $scope.additionals['invalid'] = data.invalid;
                                                                }
                                                                $mdDialog.hide();
                                                                currentModel = {};
                                                                $scope.isLoading = false;
                                                                $scope.additionals['buttonDisabled'] = false;
                                                        })
                                                        .error(function (data) {
                                                                $scope.errors = data.errors;
                                                                $scope.isLoading = false;
                                                                $scope.additionals['buttonDisabled'] = false;
                                                        });

                                        };
                                }
                        }
                };

		/* change roles */
		$scope.changeRolesModel = function (ev, path, model) {
			if($scope.mode_action == 'page') {
				$scope.controlSH = true;
				$scope.action = 'addroles';
      	angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
				$scope.additionals['invalid'] = '';
				var currentModel = {};
				angular.forEach(model, function (item, key) {
					currentModel[key] = item;
				});
				$scope.modelData = currentModel;
				$scope.cancel = function () {
					$scope.modelData = {};
					$scope.errors = {};
					$scope.controlSH = false;
				};

				$scope.updateModel = function () {
          $scope.additionals['buttonDisabled'] = true;
					$scope.isLoading = true;
					$scope.modelData['route'] = 'addRoles';
					Crud.post('form-urlencoded', $scope.modelData, path +'/addRoles')
						.success(function (data) {
							if (!angular.isUndefined(data.invalid)) {
								$scope.additionals['invalid'] = data.invalid;
							}
							currentModel = {};
							$scope.modelData = {};
							$scope.errors = {};
							$scope.isLoading = false;
              $scope.additionals['buttonDisabled'] = false;
						})
						.error(function (data) {
							$scope.errors = data.errors;
							$scope.isLoading = false;
              $scope.additionals['buttonDisabled'] = false;
						});

				};


			}
			if($scope.mode_action == 'dialog') {
				$scope.additionals['invalid'] = '';
				var currentModel = {};
				angular.forEach(model, function (item, key) {
					currentModel[key] = item;
				});

				$mdDialog.show({
					controller: DialogController,
					templateUrl: 'changeRolesDialog.tmpl.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					locals: {pathTemplate: $scope.pathTemplate, model: currentModel, additionals: $scope.additionals}
				}).then(function () {
					if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
						if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
							if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
								$scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
							}
							if (!angular.isUndefined($scope.modelData)) {
								$scope.modelData = $scope.additionals['dataCurrentModel'];
							}
						} else {
							if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
								$scope.getElement($scope.models, currentModel, $rootScope.typeId);
							}
							if (!angular.isUndefined($scope.modelData)) {
								$scope.modelData = currentModel;
							}
						}
					}
				});
				DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'additionals'];
				function DialogController($scope, $mdDialog, pathTemplate, model, additionals) {
					$scope.pathTemplate = pathTemplate;
					$scope.modelData = model;
					$scope.additionals = additionals;

					$scope.cancel = function () {
						$mdDialog.cancel();
					};
					$scope.modelData.role = [];
					angular.forEach($scope.modelData.role, function (item, index) {
						$scope.modelData.role[index] = item['id'];
					});

					$scope.changeRoles = function () {
            $scope.additionals['buttonDisabled'] = true;
						$scope.isLoading = true;

						var post = {};
						post['role'] = $scope.modelData.role;
						post['modelId'] = model.id;
						post['route'] = 'addRoles';

						Crud.post('form-urlencoded', post, path +'/addRoles')
							.success(function (data) {
								if (!angular.isUndefined(data.invalid)) {
									$scope.additionals['invalid'] = data.invalid;
								} else {
									if (!angular.isUndefined(data.currentModel)) {
										$scope.additionals['dataCurrentModel'] = data.currentModel;
									}
								}
								$mdDialog.hide();
								$scope.isLoading = false;
                                $scope.additionals['buttonDisabled'] = false;
							})
							.error(function (data) {
								$scope.errors = data.errors;
								$scope.isLoading = false;
                                $scope.additionals['buttonDisabled'] = false;
							});

					};
				}
			}

		};

		/* detail model */
		$rootScope.detailUser = function () {
			/*	console.log($route);
			 console.log($location);
			 console.log($routeParams);*/
			//$scope.controlSH = true;
			$scope.mode_action = 'dialog';

			Crud.show($routeParams.id, $scope.path)
				.success(function (data) {
					$scope.modelData = data;
				});
		}

	}]
)
